import { render } from "./xjdetails.vue?vue&type=template&id=1c70a6de&scoped=true"
import script from "./xjdetails.vue?vue&type=script&lang=js"
export * from "./xjdetails.vue?vue&type=script&lang=js"

import "./xjdetails.vue?vue&type=style&index=0&id=1c70a6de&lang=scss&scoped=true"
import "./xjdetails.vue?vue&type=style&index=1&id=1c70a6de&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c70a6de"]])

export default __exports__